export enum ImageRatioEnum {
  default = '',
  r1_1 = 'r1_1',
  r16_9 = 'r16_9',
  r16_10 = 'r16_10',
  r9_16 = 'r9_16',
  r4_3 = 'r4_3',
  r9_19 = 'r9_19',
  r21_9 = 'r21_9',
  r3_2 = 'r3_2',
  r3_4 = 'r3_4',
  r9_21 = 'r9_21',
  r14_9 = 'r14_9',
  r30_9 = 'r30_9',
  r5_4 = 'r5_4',
  r2_1 = 'r2_1',
  r15_8 = 'r15_8',
  r5_3 = 'r5_3'
}
